// @flow
import * as React from 'react'
import { withRouter } from 'react-router-dom'
import ChartPanel from './chart_realizations'
import stylesFicus from '../styles'
import type { AnalysisPanelType } from '../reducers/analysis_panel'
import type { AnalyzeFrameworkBarType } from '../reducers/analyze_framework_bar'
import type { PointDataType } from './chart_realizations'

type Props = {
    config: AnalyzeFrameworkBarType,
    analysisPanel: AnalysisPanelType,
    setFicusConfig: Function,
    theme: stylesFicus,
    tocVisible: boolean,
}

type State = {
    height: number | null,
    redraw: boolean,
}

export const rasterNum = (r: string) => r.substr(r.length - 7, 3)

class AnalysisPanel extends React.Component<Props, State> {
    tocVisible: boolean
    container: any

    constructor(props: Props) {
        super(props)
        this.tocVisible = false
        this.state = {
            height: null,
            redraw: true,
        }
    }

    componentDidMount() {
        window.addEventListener('resize', () => this.updateDimensions())
        this.updateDimensions()
        console.warn('check setTimeout in analysis panel')
        setTimeout(() => {
            this.updateDimensions()
        }, 50)
    }

    componentDidUpdate() {
        // this.setState({ ...this.state, redraw: false })
    }

    updateDimensions() {
        const dims = this.getDims()
        if (dims) {
            this.setState({ ...this.state, height: dims.height - 36, redraw: true })
        }
    }

    getDims() {
        const el = this.container
        if (el) {
            const dims = el.getBoundingClientRect()
            return dims
        }
        return null
    }

    render() {
        const rootCssStyles = this.props.theme
        const rootClassNames = [this.props.theme.analysisPanel, this.props.theme.mapToolbarPanelClosed, this.props.theme.analyzeFramework]
        rootClassNames.push(this.props.tocVisible ? this.props.theme.contextBarOpen : this.props.theme.contextBarClosed)

        // Get list of realizations
        const pointData: PointDataType = []
        // Default ordering is from 0..nframes-1. Grayswan is always complete, so we can use this to generate the list.
        let realizations = this.props.analysisPanel.grayswan.map(v => rasterNum(v[1]))
        let count = this.props.analysisPanel.grayswan.length
        const interval = this.props.config.iInterval
        if (this.props.config.iterationType === 'value') {
            // Get list of realizations from cell values
            if (this.props.analysisPanel.analysisLocation) {
                realizations = this.props.analysisPanel.analysisLocation.values.map(v => rasterNum(v[1]))
            }
        } else if (this.props.config.iterationType === 'grayswan') {
            // Get list of realizations from gray swan list
            realizations = this.props.analysisPanel.grayswan.map(v => rasterNum(v[1]))
        }

        // There are two types of data: cell values and the grayswans. Sort if needed, taking advantage of the fact that
        //   the length of realizations array will always be the grayswan length if no (ie, default) ordering is used.
        const order = this.props.config.iterationOrder.length ? this.props.config.iterationOrder : realizations.map((r, i) => i)
        if (this.props.analysisPanel.grayswan.length) {
            pointData.push({
                name: `Gray Swan (#${this.props.analysisPanel.grayswan.length})`,
                color: 'gray',
                values: order.map(i => this.props.analysisPanel.grayswan[i][0]),
                yAxis: 'grayswan',
            })
        }
        if (this.props.analysisPanel.analysisLocation) {
            const loc = this.props.analysisPanel.analysisLocation
            if (loc.values.length) {
                count = loc.values.filter(v => v[0] !== null).length
                pointData.push({
                    name: `Value at Location ${loc.title} (#${count})`,
                    color: 'lightblue',
                    values: order.map(i => loc.values[i][0]),
                    yAxis: 'values',
                })
            }

            if (loc.valuesGrayswan.length) {
                // Add local grayswan data
                pointData.push({
                    name: 'Gray Swan at Location',
                    color: 'lightgray',
                    values: order.map(i => loc.valuesGrayswan[i][0]),
                    yAxis: 'grayswan',
                })
            }
        }
        const realizationsSorted = order.map(i => realizations[i])
        const redraw = this.props.tocVisible !== this.tocVisible || this.state.redraw
        this.tocVisible = this.props.tocVisible

        // Don't want to trigger a state change, just update that the chart doesn't need to be redrawn again next time around.
        this.state.redraw = false

        return (
            <div className={rootClassNames.join(' ')}>
                <div className={this.props.theme.controlBarTop} ref={(c) => { this.container = c }}>
                    <ChartPanel
                        pointData={pointData}
                        realizations={realizationsSorted}
                        chartStyle={{ width: null, height: this.state.height, spacingBottom: 0 }}
                        iframe={this.props.config.mode === '_allRealizations' ? this.props.config.iframe : 0}
                        iframeOrder={order}
                        redraw={redraw}
                        setFrame={iframe => this.props.setFicusConfig({ iframe, started: false })}
                    />
                </div>
            </div>
        )
    }
}

export default withRouter(AnalysisPanel)
